import { initContract } from '@ts-rest/core'
import z from 'zod'

const c = initContract()

const ReplicationConnectionSchema = z.object({
  replicationMode: z.string(),
  result: z.string(),
})

export const communicationServiceContract = c.router({
  getHealth: {
    method: 'GET',
    path: '/health',
    summary: 'Health check endpoint',
    description: 'Checks if the service is healthy',
    responses: {
      200: z.object({
        status: z.string(),
      }),
    },
  },
  getReplicationStatus: {
    method: 'GET',
    path: '/replication-status',
    summary: 'Replication routing check',
    description: 'Verifies that queries are correctly routed to the primary and read-replica connections',
    responses: {
      200: z.object({
        replicationConfigured: z.boolean(),
        primary: ReplicationConnectionSchema,
        replica: ReplicationConnectionSchema.nullable(),
      }),
    },
  },
})
